import { v4 as uuidv4 } from 'uuid';

export function TabList(props = {}, childrenComponents = []) {
	return {
		componentName: 'TabList',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
